import { render, staticRenderFns } from "./NewAsset.vue?vue&type=template&id=2798670b&scoped=true"
import script from "./NewAsset.vue?vue&type=script&lang=js"
export * from "./NewAsset.vue?vue&type=script&lang=js"
import style0 from "./NewAsset.vue?vue&type=style&index=0&id=2798670b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2798670b",
  null
  
)

export default component.exports